import script from "./RecommendationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendationsTable.vue?vue&type=script&setup=true&lang=js"

import "./RecommendationsTable.vue?vue&type=style&index=0&id=2610dc05&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2610dc05"]])

export default __exports__